// extracted by mini-css-extract-plugin
export default {"prayer":"prayer--gcTQk","title":"title--JszDT","content":"content--j_D3z","info":"info--Ebd0l"};